<template>
  <div class="content d-flex flex-column flex-column-fluid" id="kt_content">
    <!--begin::Subheader-->
    <div class="subheader py-6 py-lg-8 subheader-transparent" id="kt_subheader">
      <div
        class="container d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap"
      >
        <!--begin::Info-->
        <div class="d-flex align-items-center flex-wrap mr-1">
          <!--begin::Page Heading-->
          <div class="d-flex align-items-baseline flex-wrap mr-5">
            <!--begin::Page Title-->
            <h1 class="pages-title my-1 mr-5">
              ACTE D'ENGAGEMENT <span>#{{ acte_engagement.reference }}</span>
            </h1>
            <!--end::Page Title-->
          </div>
          <!--end::Page Heading-->
        </div>
        <!--end::Info-->
      </div>
    </div>
    <!--end::Subheader-->

    <div class="d-flex flex-column-fluid">
      <!--begin::Container-->
      <div class="container">
        <div class="row">
          <div class="col-md-8">
            <div class="card card-custom card-labels-values">
              <div class="card-body">
                <div class="form-group d-flex justify-content-between">
                  <div>
                    <h4 class="m-0">
                      {{ acte_engagement.vacataire.nom }}
                      {{ acte_engagement.vacataire.prenom }}
                    </h4>
                    <p class="separator"></p>
                  </div>
                  <div>
                    <div class="d-flex justify-content-between">
                      <div
                        class="font-size-16 badge app-badge d-flex justify-content-between"
                      >
                        <span class="left">CIN</span>
                        <span class="right">
                          {{ acte_engagement.vacataire.cin }}
                        </span>
                      </div>
                      <a href="#" class="ml-5 edit-btn btn btn-sm bg-light">
                        <span class="svg-icon svg-icon-primary svg-icon-2x">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            width="24px"
                            height="24px"
                            viewBox="0 0 24 24"
                            version="1.1"
                          >
                            <g
                              stroke="none"
                              stroke-width="1"
                              fill="none"
                              fill-rule="evenodd"
                            >
                              <rect x="0" y="0" width="24" height="24" />
                              <path
                                d="M3,12 C3,12 5.45454545,6 12,6 C16.9090909,6 21,12 21,12 C21,12 16.9090909,18 12,18 C5.45454545,18 3,12 3,12 Z"
                                fill="#000000"
                                fill-rule="nonzero"
                                opacity="0.3"
                              />
                              <path
                                d="M12,15 C10.3431458,15 9,13.6568542 9,12 C9,10.3431458 10.3431458,9 12,9 C13.6568542,9 15,10.3431458 15,12 C15,13.6568542 13.6568542,15 12,15 Z"
                                fill="#000000"
                                opacity="0.3"
                              />
                            </g>
                          </svg>
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-lg-6">
                    <label class="text">Date de naissance</label>
                    <label class="d-block value">
                      {{ acte_engagement.vacataire.date_naissance }}
                    </label>
                  </div>
                  <div class="col-lg-6">
                    <label class="text">Nationalité</label>
                    <label class="d-block value">Marocaine</label>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-lg-6">
                    <label class="text">Email personnel</label>
                    <label class="d-block value">
                      {{ acte_engagement.vacataire.email_personnel }}
                    </label>
                  </div>
                  <div class="col-lg-6">
                    <label class="text">Email UIR</label>
                    <label class="d-block value">
                      {{ acte_engagement.vacataire.email_uir }}
                    </label>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-lg-6">
                    <label class="text">Téléphone</label>
                    <label class="d-block value">
                      {{ acte_engagement.vacataire.tel }}
                    </label>
                  </div>
                  <div class="col-lg-6">
                    <label class="text">Adresse</label>
                    <label class="d-block value">
                      {{ acte_engagement.vacataire.adresse }}
                    </label>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-lg-12">
                    <div
                      class="font-size-18 badge app-badge full-width d-flex justify-content-between"
                    >
                      <span class="left">RIB</span>
                      <span class="right">
                        {{ acte_engagement.vacataire.rib }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="card card-custom attached-files">
              <div class="card-body px-5">
                <h4 class="title mb-5">
                  <span class="svg-icon svg-icon-2x mr-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      width="24px"
                      height="24px"
                      viewBox="0 0 24 24"
                      version="1.1"
                    >
                      <g
                        stroke="none"
                        stroke-width="1"
                        fill="none"
                        fill-rule="evenodd"
                      >
                        <rect x="0" y="0" width="24" height="24" />
                        <path
                          d="M11.7573593,15.2426407 L8.75735931,15.2426407 C8.20507456,15.2426407 7.75735931,15.6903559 7.75735931,16.2426407 C7.75735931,16.7949254 8.20507456,17.2426407 8.75735931,17.2426407 L11.7573593,17.2426407 L11.7573593,18.2426407 C11.7573593,19.3472102 10.8619288,20.2426407 9.75735931,20.2426407 L5.75735931,20.2426407 C4.65278981,20.2426407 3.75735931,19.3472102 3.75735931,18.2426407 L3.75735931,14.2426407 C3.75735931,13.1380712 4.65278981,12.2426407 5.75735931,12.2426407 L9.75735931,12.2426407 C10.8619288,12.2426407 11.7573593,13.1380712 11.7573593,14.2426407 L11.7573593,15.2426407 Z"
                          fill="#000000"
                          opacity="0.3"
                          transform="translate(7.757359, 16.242641) rotate(-45.000000) translate(-7.757359, -16.242641) "
                        />
                        <path
                          d="M12.2426407,8.75735931 L15.2426407,8.75735931 C15.7949254,8.75735931 16.2426407,8.30964406 16.2426407,7.75735931 C16.2426407,7.20507456 15.7949254,6.75735931 15.2426407,6.75735931 L12.2426407,6.75735931 L12.2426407,5.75735931 C12.2426407,4.65278981 13.1380712,3.75735931 14.2426407,3.75735931 L18.2426407,3.75735931 C19.3472102,3.75735931 20.2426407,4.65278981 20.2426407,5.75735931 L20.2426407,9.75735931 C20.2426407,10.8619288 19.3472102,11.7573593 18.2426407,11.7573593 L14.2426407,11.7573593 C13.1380712,11.7573593 12.2426407,10.8619288 12.2426407,9.75735931 L12.2426407,8.75735931 Z"
                          fill="#000000"
                          transform="translate(16.242641, 7.757359) rotate(-45.000000) translate(-16.242641, -7.757359) "
                        />
                        <path
                          d="M5.89339828,3.42893219 C6.44568303,3.42893219 6.89339828,3.87664744 6.89339828,4.42893219 L6.89339828,6.42893219 C6.89339828,6.98121694 6.44568303,7.42893219 5.89339828,7.42893219 C5.34111353,7.42893219 4.89339828,6.98121694 4.89339828,6.42893219 L4.89339828,4.42893219 C4.89339828,3.87664744 5.34111353,3.42893219 5.89339828,3.42893219 Z M11.4289322,5.13603897 C11.8194565,5.52656326 11.8194565,6.15972824 11.4289322,6.55025253 L10.0147186,7.96446609 C9.62419433,8.35499039 8.99102936,8.35499039 8.60050506,7.96446609 C8.20998077,7.5739418 8.20998077,6.94077682 8.60050506,6.55025253 L10.0147186,5.13603897 C10.4052429,4.74551468 11.0384079,4.74551468 11.4289322,5.13603897 Z M0.600505063,5.13603897 C0.991029355,4.74551468 1.62419433,4.74551468 2.01471863,5.13603897 L3.42893219,6.55025253 C3.81945648,6.94077682 3.81945648,7.5739418 3.42893219,7.96446609 C3.0384079,8.35499039 2.40524292,8.35499039 2.01471863,7.96446609 L0.600505063,6.55025253 C0.209980772,6.15972824 0.209980772,5.52656326 0.600505063,5.13603897 Z"
                          fill="#000000"
                          opacity="0.3"
                          transform="translate(6.014719, 5.843146) rotate(-45.000000) translate(-6.014719, -5.843146) "
                        />
                        <path
                          d="M17.9142136,15.4497475 C18.4664983,15.4497475 18.9142136,15.8974627 18.9142136,16.4497475 L18.9142136,18.4497475 C18.9142136,19.0020322 18.4664983,19.4497475 17.9142136,19.4497475 C17.3619288,19.4497475 16.9142136,19.0020322 16.9142136,18.4497475 L16.9142136,16.4497475 C16.9142136,15.8974627 17.3619288,15.4497475 17.9142136,15.4497475 Z M23.4497475,17.1568542 C23.8402718,17.5473785 23.8402718,18.1805435 23.4497475,18.5710678 L22.0355339,19.9852814 C21.6450096,20.3758057 21.0118446,20.3758057 20.6213203,19.9852814 C20.2307961,19.5947571 20.2307961,18.9615921 20.6213203,18.5710678 L22.0355339,17.1568542 C22.4260582,16.76633 23.0592232,16.76633 23.4497475,17.1568542 Z M12.6213203,17.1568542 C13.0118446,16.76633 13.6450096,16.76633 14.0355339,17.1568542 L15.4497475,18.5710678 C15.8402718,18.9615921 15.8402718,19.5947571 15.4497475,19.9852814 C15.0592232,20.3758057 14.4260582,20.3758057 14.0355339,19.9852814 L12.6213203,18.5710678 C12.2307961,18.1805435 12.2307961,17.5473785 12.6213203,17.1568542 Z"
                          fill="#000000"
                          opacity="0.3"
                          transform="translate(18.035534, 17.863961) scale(1, -1) rotate(45.000000) translate(-18.035534, -17.863961) "
                        />
                      </g>
                    </svg>
                  </span>
                  FICHIERS ATTACHÉS
                </h4>
                <div class="files-items">
                  <div
                    class="attached-item-file d-flex align-items-center mb-3"
                  >
                    <!--begin::Symbol-->
                    <div class="symbol symbol-35 flex-shrink-0 mr-3">
                      <img src="/assets/keen/assets/media/pdf-icon.png" />
                    </div>
                    <!--end::Symbol-->
                    <!--begin::Content-->
                    <div class="d-flex flex-wrap flex-row-fluid">
                      <!--begin::Text-->
                      <div class="d-flex flex-column pr-5 flex-grow-1">
                        <a href="#" class="mb-1 title" style="font-size: 12px">
                          {{ acte_engagement.reference }}-Géneré
                        </a>
                        <span class="date">
                          {{
                            acte_engagement.updated_at | moment("DD/MM/YYYY")
                          }}
                        </span>
                      </div>
                      <!--end::Text-->
                      <a
                        v-if="Object.keys(this.acte_non_legalise).length != 0"
                        href="#"
                        class="fl btn btn-sm btn-icon btn-bg-light btn-icon-success p-6"
                      >
                        <span class="svg-icon svg-icon-primary svg-icon-2x">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            width="24px"
                            height="24px"
                            viewBox="0 0 24 24"
                            version="1.1"
                          >
                            <g
                              stroke="none"
                              stroke-width="1"
                              fill="none"
                              fill-rule="evenodd"
                            >
                              <polygon points="0 0 24 0 24 24 0 24" />
                              <path
                                d="M5.85714286,2 L13.7364114,2 C14.0910962,2 14.4343066,2.12568431 14.7051108,2.35473959 L19.4686994,6.3839416 C19.8056532,6.66894833 20,7.08787823 20,7.52920201 L20,20.0833333 C20,21.8738751 19.9795521,22 18.1428571,22 L5.85714286,22 C4.02044787,22 4,21.8738751 4,20.0833333 L4,3.91666667 C4,2.12612489 4.02044787,2 5.85714286,2 Z"
                                fill="#000000"
                                fill-rule="nonzero"
                                opacity="0.3"
                              />
                              <path
                                d="M14.8875071,11.8306874 L12.9310336,11.8306874 L12.9310336,9.82301606 C12.9310336,9.54687369 12.707176,9.32301606 12.4310336,9.32301606 L11.4077349,9.32301606 C11.1315925,9.32301606 10.9077349,9.54687369 10.9077349,9.82301606 L10.9077349,11.8306874 L8.9512614,11.8306874 C8.67511903,11.8306874 8.4512614,12.054545 8.4512614,12.3306874 C8.4512614,12.448999 8.49321518,12.5634776 8.56966458,12.6537723 L11.5377874,16.1594334 C11.7162223,16.3701835 12.0317191,16.3963802 12.2424692,16.2179453 C12.2635563,16.2000915 12.2831273,16.1805206 12.3009811,16.1594334 L15.2691039,12.6537723 C15.4475388,12.4430222 15.4213421,12.1275254 15.210592,11.9490905 C15.1202973,11.8726411 15.0058187,11.8306874 14.8875071,11.8306874 Z"
                                fill="#000000"
                              />
                            </g>
                          </svg>
                        </span>
                      </a>
                    </div>
                    <!--end::Content-->
                  </div>

                  <div
                    class="attached-item-file d-flex align-items-center mb-3"
                    :class="{
                      missing: Object.keys(this.acte_legalise).length == 0,
                    }"
                  >
                    <!--begin::Symbol-->
                    <div class="symbol symbol-35 flex-shrink-0 mr-3">
                      <img src="/assets/keen/assets/media/pdf-icon.png" />
                    </div>
                    <!--end::Symbol-->
                    <!--begin::Content-->
                    <div class="d-flex flex-wrap flex-row-fluid">
                      <!--begin::Text-->
                      <div class="d-flex flex-column pr-5 flex-grow-1">
                        <a href="#" class="mb-1 title" style="font-size: 12px">
                          {{ acte_engagement.reference }}-LÉGALISÉ
                        </a>

                        <span
                          v-if="Object.keys(this.acte_legalise).length != 0"
                          class="date"
                        >
                          {{ acte_legalise.updated_at }}
                        </span>
                        <span v-else class="date">Manquant…</span>
                      </div>

                      <!--end::Text-->

                      <a
                        v-if="Object.keys(this.acte_legalise).length != 0"
                        href="#"
                        class="fl btn btn-sm btn-icon btn-bg-light btn-icon-success p-6"
                      >
                        <span class="svg-icon svg-icon-primary svg-icon-2x">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            width="24px"
                            height="24px"
                            viewBox="0 0 24 24"
                            version="1.1"
                          >
                            <g
                              stroke="none"
                              stroke-width="1"
                              fill="none"
                              fill-rule="evenodd"
                            >
                              <polygon points="0 0 24 0 24 24 0 24" />
                              <path
                                d="M5.85714286,2 L13.7364114,2 C14.0910962,2 14.4343066,2.12568431 14.7051108,2.35473959 L19.4686994,6.3839416 C19.8056532,6.66894833 20,7.08787823 20,7.52920201 L20,20.0833333 C20,21.8738751 19.9795521,22 18.1428571,22 L5.85714286,22 C4.02044787,22 4,21.8738751 4,20.0833333 L4,3.91666667 C4,2.12612489 4.02044787,2 5.85714286,2 Z"
                                fill="#000000"
                                fill-rule="nonzero"
                                opacity="0.3"
                              />
                              <path
                                d="M14.8875071,11.8306874 L12.9310336,11.8306874 L12.9310336,9.82301606 C12.9310336,9.54687369 12.707176,9.32301606 12.4310336,9.32301606 L11.4077349,9.32301606 C11.1315925,9.32301606 10.9077349,9.54687369 10.9077349,9.82301606 L10.9077349,11.8306874 L8.9512614,11.8306874 C8.67511903,11.8306874 8.4512614,12.054545 8.4512614,12.3306874 C8.4512614,12.448999 8.49321518,12.5634776 8.56966458,12.6537723 L11.5377874,16.1594334 C11.7162223,16.3701835 12.0317191,16.3963802 12.2424692,16.2179453 C12.2635563,16.2000915 12.2831273,16.1805206 12.3009811,16.1594334 L15.2691039,12.6537723 C15.4475388,12.4430222 15.4213421,12.1275254 15.210592,11.9490905 C15.1202973,11.8726411 15.0058187,11.8306874 14.8875071,11.8306874 Z"
                                fill="#000000"
                              />
                            </g>
                          </svg>
                        </span>
                      </a>
                    </div>
                    <!--end::Content-->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--begin::Entry-->
    <div class="pt-8 d-flex">
      <!--begin::Container-->
      <div class="container">
        <div class="row">
          <div class="col-xl-12">
            <div class="d-flex align-items-end justify-content-between">
              <h5 class="card-title">AVENANT(S)</h5>
              <div
                class="mr-2"
                v-if="
                  acte_engagement.etape == 'Valider par DOYEN' &&
                  (user.role.nom == 'DE' || user.role.nom == 'ASST')
                "
              >
                <button
                  type="button"
                  data-toggle="modal"
                  data-target="#AddAvenant"
                  class="mb-3 btn btn-sm bg-green text-color-green py-4 pl-6 pr-10"
                  @click="new_avenant_modal()"
                >
                  <span
                    class="svg-size-20 svg-icon svg-icon-green svg-icon-2x mr-5"
                  >
                    <!--begin::Svg Icon | path:/var/www/preview.keenthemes.com/keen/releases/2020-10-07-041015/theme/demo1/dist/../src/media/svg/icons/Code/Plus.svg-->
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      width="24px"
                      height="24px"
                      viewBox="0 0 24 24"
                      version="1.1"
                    >
                      <g
                        stroke="none"
                        stroke-width="1"
                        fill="none"
                        fill-rule="evenodd"
                      >
                        <rect x="0" y="0" width="24" height="24"></rect>
                        <circle
                          fill="#000000"
                          opacity="0.3"
                          cx="12"
                          cy="12"
                          r="10"
                        ></circle>
                        <path
                          d="M11,11 L11,7 C11,6.44771525 11.4477153,6 12,6 C12.5522847,6 13,6.44771525 13,7 L13,11 L17,11 C17.5522847,11 18,11.4477153 18,12 C18,12.5522847 17.5522847,13 17,13 L13,13 L13,17 C13,17.5522847 12.5522847,18 12,18 C11.4477153,18 11,17.5522847 11,17 L11,13 L7,13 C6.44771525,13 6,12.5522847 6,12 C6,11.4477153 6.44771525,11 7,11 L11,11 Z"
                          fill="#000000"
                        ></path>
                      </g>
                    </svg>
                  </span>
                  <span class="font-size-14 vertical-align-middle">
                    Ajouter un avenant
                  </span>
                </button>
              </div>
            </div>

            <div class="bg-white-raduis py-7 px-5 mb-10">
              <div
                v-if="acte_engagement.etape != 'Valider par DOYEN'"
                class="empty-datas py-5"
              >
                <div class="d-flex justify-content-center">
                  <span class="svg-icon fill- svg-icon-5x">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      width="24px"
                      height="24px"
                      viewBox="0 0 24 24"
                      version="1.1"
                    >
                      <g
                        stroke="none"
                        stroke-width="1"
                        fill="none"
                        fill-rule="evenodd"
                      >
                        <rect x="0" y="0" width="24" height="24" />
                        <path
                          d="M4,4 L11.6314229,2.5691082 C11.8750185,2.52343403 12.1249815,2.52343403 12.3685771,2.5691082 L20,4 L20,13.2830094 C20,16.2173861 18.4883464,18.9447835 16,20.5 L12.5299989,22.6687507 C12.2057287,22.8714196 11.7942713,22.8714196 11.4700011,22.6687507 L8,20.5 C5.51165358,18.9447835 4,16.2173861 4,13.2830094 L4,4 Z"
                          fill="#000000"
                          opacity="0.3"
                        />
                        <path
                          d="M10.5857864,12 L9.17157288,10.5857864 C8.78104858,10.1952621 8.78104858,9.56209717 9.17157288,9.17157288 C9.56209717,8.78104858 10.1952621,8.78104858 10.5857864,9.17157288 L12,10.5857864 L13.4142136,9.17157288 C13.8047379,8.78104858 14.4379028,8.78104858 14.8284271,9.17157288 C15.2189514,9.56209717 15.2189514,10.1952621 14.8284271,10.5857864 L13.4142136,12 L14.8284271,13.4142136 C15.2189514,13.8047379 15.2189514,14.4379028 14.8284271,14.8284271 C14.4379028,15.2189514 13.8047379,15.2189514 13.4142136,14.8284271 L12,13.4142136 L10.5857864,14.8284271 C10.1952621,15.2189514 9.56209717,15.2189514 9.17157288,14.8284271 C8.78104858,14.4379028 8.78104858,13.8047379 9.17157288,13.4142136 L10.5857864,12 Z"
                          fill="#000000"
                        />
                      </g>
                    </svg>
                  </span>
                </div>
                <div class="d-flex justify-content-center">
                  <span class="color-A7AED3 font-size-16">
                    Aucun avenant trouvé…
                  </span>
                </div>
              </div>
              <table
                v-if="acte_engagement.etape == 'Valider par DOYEN'"
                class="table table-borderless mb-0 table-v1"
              >
                <thead>
                  <tr>
                    <th scope="col">Réf.</th>
                    <th scope="col">Type.</th>
                    <th scope="col">Début vacation</th>
                    <th scope="col">Fin vacation</th>
                    <th scope="col">Status</th>
                    <th scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="avenant in avenants" v-bind:key="avenant.id">
                    <td>#{{ avenant.reference }}</td>
                    <td>{{ avenant.type }}</td>
                    <td class="col-date">
                      <span class="svg-icon svg-icon-2x mr-1">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          width="24px"
                          height="24px"
                          viewBox="0 0 24 24"
                          version="1.1"
                        >
                          <g
                            stroke="none"
                            stroke-width="1"
                            fill="none"
                            fill-rule="evenodd"
                          >
                            <rect x="0" y="0" width="24" height="24" />
                            <rect
                              fill="#000000"
                              x="2"
                              y="5"
                              width="19"
                              height="4"
                              rx="1"
                            />
                            <rect
                              fill="#000000"
                              opacity="0.3"
                              x="2"
                              y="11"
                              width="19"
                              height="10"
                              rx="1"
                            />
                          </g>
                        </svg>
                      </span>
                      {{ avenant.date_debut_avenant | moment("DD/MM/YYYY") }}
                    </td>
                    <td class="col-date">
                      <span class="svg-icon svg-icon-2x mr-1">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          width="24px"
                          height="24px"
                          viewBox="0 0 24 24"
                          version="1.1"
                        >
                          <g
                            stroke="none"
                            stroke-width="1"
                            fill="none"
                            fill-rule="evenodd"
                          >
                            <rect x="0" y="0" width="24" height="24" />
                            <rect
                              fill="#000000"
                              x="2"
                              y="5"
                              width="19"
                              height="4"
                              rx="1"
                            />
                            <rect
                              fill="#000000"
                              opacity="0.3"
                              x="2"
                              y="11"
                              width="19"
                              height="10"
                              rx="1"
                            />
                          </g>
                        </svg>
                      </span>
                      {{ avenant.date_fin_avenant | moment("DD/MM/YYYY") }}
                    </td>
                    <td>
                      <p
                        v-if="avenant.etape == 'Valider par DOYEN'"
                        class="icon-text"
                      >
                        <i class="icon-xl la la-check-circle"></i>
                        <span>Validé par Doyen</span>
                      </p>
                      <span v-else>{{ avenant.etape }}</span>
                    </td>
                    <td class="dropdown-action">
                      <div class="dropdown dropdown-inline float-right">
                        <button
                          type="button"
                          class="btn btn-hover-light-primary btn-icon btn-sm"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          <i class="ki ki-more-ver"></i>
                        </button>
                        <div
                          class="dropdown-menu dropdown-menu-sm dropdown-menu-right px-2"
                        >
                          <a
                            class="dropdown-item"
                            @click="show_avenant(avenant)"
                            href="#"
                          >
                            Voir
                          </a>
                          <button
                            @click="delete_avenant_modal(avenant)"
                            v-if="avenant.etape == 'Initialiser'"
                            class="dropdown-item deleteAvenant"
                          >
                            Supprimer avenant
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <!--end::Container-->
    </div>
    <!--end::avenants-->
    <!--begin::Steper-->
    <div class="d-flex flex-column-fluid etat-validation">
      <!--begin::Container-->
      <div class="container">
        <div class="card card-custom">
          <div class="card-body p-0 pb-5">
            <!--begin: Wizard-->
            <div class="wizard wizard-3" data-wizard-clickable="true">
              <div class="etat-validation-title">
                <h4>ÉTAT DE VALIDATION</h4>
              </div>
              <!--begin: Wizard Nav-->
              <div class="wizard-nav">
                <div class="wizard-steps px-3 py-5 px-lg-8 py-lg-7">
                  <!--begin::Wizard Step 1 Nav-->
                  <div
                    class="wizard-step"
                    data-wizard-type="step"
                    id="Inititialisation"
                  >
                    <div class="wizard-label">
                      <span class="wizard-number">1</span>
                      <span class="wizard-check">
                        <span class="svg-icon svg-icon-2x">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            width="24px"
                            height="24px"
                            viewBox="0 0 24 24"
                            version="1.1"
                          >
                            <g
                              stroke="none"
                              stroke-width="1"
                              fill="none"
                              fill-rule="evenodd"
                            >
                              <polygon points="0 0 24 0 24 24 0 24" />
                              <path
                                d="M6.26193932,17.6476484 C5.90425297,18.0684559 5.27315905,18.1196257 4.85235158,17.7619393 C4.43154411,17.404253 4.38037434,16.773159 4.73806068,16.3523516 L13.2380607,6.35235158 C13.6013618,5.92493855 14.2451015,5.87991302 14.6643638,6.25259068 L19.1643638,10.2525907 C19.5771466,10.6195087 19.6143273,11.2515811 19.2474093,11.6643638 C18.8804913,12.0771466 18.2484189,12.1143273 17.8356362,11.7474093 L14.0997854,8.42665306 L6.26193932,17.6476484 Z"
                                fill="#000000"
                                fill-rule="nonzero"
                                transform="translate(11.999995, 12.000002) rotate(-180.000000) translate(-11.999995, -12.000002)"
                              />
                            </g>
                          </svg>
                        </span>
                      </span>
                    </div>
                    <div class="wizard-title">Inititialisation</div>
                  </div>
                  <!--end::Wizard Step 1 Nav-->
                  <!--begin::Wizard Step 2 Nav-->
                  <div
                    class="wizard-step"
                    id="Distribution_des_activite"
                    data-wizard-type="step"
                  >
                    <div class="wizard-label">
                      <span class="wizard-number">2</span>
                      <span class="wizard-check">
                        <span class="svg-icon svg-icon-2x">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            width="24px"
                            height="24px"
                            viewBox="0 0 24 24"
                            version="1.1"
                          >
                            <g
                              stroke="none"
                              stroke-width="1"
                              fill="none"
                              fill-rule="evenodd"
                            >
                              <polygon points="0 0 24 0 24 24 0 24" />
                              <path
                                d="M6.26193932,17.6476484 C5.90425297,18.0684559 5.27315905,18.1196257 4.85235158,17.7619393 C4.43154411,17.404253 4.38037434,16.773159 4.73806068,16.3523516 L13.2380607,6.35235158 C13.6013618,5.92493855 14.2451015,5.87991302 14.6643638,6.25259068 L19.1643638,10.2525907 C19.5771466,10.6195087 19.6143273,11.2515811 19.2474093,11.6643638 C18.8804913,12.0771466 18.2484189,12.1143273 17.8356362,11.7474093 L14.0997854,8.42665306 L6.26193932,17.6476484 Z"
                                fill="#000000"
                                fill-rule="nonzero"
                                transform="translate(11.999995, 12.000002) rotate(-180.000000) translate(-11.999995, -12.000002)"
                              />
                            </g>
                          </svg>
                        </span>
                      </span>
                    </div>
                    <div class="wizard-title">
                      Distribution<br />
                      des activités
                    </div>
                  </div>
                  <!--end::Wizard Step 2 Nav-->
                  <!--begin::Wizard Step 3 Nav-->
                  <div
                    class="wizard-step"
                    id="validation_vacataire"
                    data-wizard-type="step"
                  >
                    <div class="wizard-label">
                      <span class="wizard-number">3</span>
                      <span class="wizard-check">
                        <span class="svg-icon svg-icon-2x">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            width="24px"
                            height="24px"
                            viewBox="0 0 24 24"
                            version="1.1"
                          >
                            <g
                              stroke="none"
                              stroke-width="1"
                              fill="none"
                              fill-rule="evenodd"
                            >
                              <polygon points="0 0 24 0 24 24 0 24" />
                              <path
                                d="M6.26193932,17.6476484 C5.90425297,18.0684559 5.27315905,18.1196257 4.85235158,17.7619393 C4.43154411,17.404253 4.38037434,16.773159 4.73806068,16.3523516 L13.2380607,6.35235158 C13.6013618,5.92493855 14.2451015,5.87991302 14.6643638,6.25259068 L19.1643638,10.2525907 C19.5771466,10.6195087 19.6143273,11.2515811 19.2474093,11.6643638 C18.8804913,12.0771466 18.2484189,12.1143273 17.8356362,11.7474093 L14.0997854,8.42665306 L6.26193932,17.6476484 Z"
                                fill="#000000"
                                fill-rule="nonzero"
                                transform="translate(11.999995, 12.000002) rotate(-180.000000) translate(-11.999995, -12.000002)"
                              />
                            </g>
                          </svg>
                        </span>
                      </span>
                    </div>
                    <div class="wizard-title">
                      Validation par <br />vacataire
                    </div>
                  </div>
                  <!--end::Wizard Step 3 Nav-->
                  <!--begin::Wizard Step 4 Nav-->
                  <div
                    class="wizard-step"
                    id="validation_DE"
                    data-wizard-type="step"
                  >
                    <div class="wizard-label">
                      <span class="wizard-number">4</span>
                      <span class="wizard-check">
                        <span class="svg-icon svg-icon-2x">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            width="24px"
                            height="24px"
                            viewBox="0 0 24 24"
                            version="1.1"
                          >
                            <g
                              stroke="none"
                              stroke-width="1"
                              fill="none"
                              fill-rule="evenodd"
                            >
                              <polygon points="0 0 24 0 24 24 0 24" />
                              <path
                                d="M6.26193932,17.6476484 C5.90425297,18.0684559 5.27315905,18.1196257 4.85235158,17.7619393 C4.43154411,17.404253 4.38037434,16.773159 4.73806068,16.3523516 L13.2380607,6.35235158 C13.6013618,5.92493855 14.2451015,5.87991302 14.6643638,6.25259068 L19.1643638,10.2525907 C19.5771466,10.6195087 19.6143273,11.2515811 19.2474093,11.6643638 C18.8804913,12.0771466 18.2484189,12.1143273 17.8356362,11.7474093 L14.0997854,8.42665306 L6.26193932,17.6476484 Z"
                                fill="#000000"
                                fill-rule="nonzero"
                                transform="translate(11.999995, 12.000002) rotate(-180.000000) translate(-11.999995, -12.000002)"
                              />
                            </g>
                          </svg>
                        </span>
                      </span>
                    </div>
                    <div class="wizard-title">
                      Validation par <br />Doyen Établissement
                    </div>
                  </div>
                  <!--end::Wizard Step 4 Nav-->
                  <!--begin::Wizard Step 5 Nav-->
                  <div
                    class="wizard-step"
                    id="validation_DOYEN"
                    data-wizard-type="step"
                  >
                    <div class="wizard-label">
                      <span class="wizard-number">5</span>
                      <span class="wizard-check">
                        <span class="svg-icon svg-icon-2x">
                          <!--begin::Svg Icon | path:assets/media/svg/icons/Navigation/Check.svg-->
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            width="24px"
                            height="24px"
                            viewBox="0 0 24 24"
                            version="1.1"
                          >
                            <g
                              stroke="none"
                              stroke-width="1"
                              fill="none"
                              fill-rule="evenodd"
                            >
                              <polygon points="0 0 24 0 24 24 0 24" />
                              <path
                                d="M6.26193932,17.6476484 C5.90425297,18.0684559 5.27315905,18.1196257 4.85235158,17.7619393 C4.43154411,17.404253 4.38037434,16.773159 4.73806068,16.3523516 L13.2380607,6.35235158 C13.6013618,5.92493855 14.2451015,5.87991302 14.6643638,6.25259068 L19.1643638,10.2525907 C19.5771466,10.6195087 19.6143273,11.2515811 19.2474093,11.6643638 C18.8804913,12.0771466 18.2484189,12.1143273 17.8356362,11.7474093 L14.0997854,8.42665306 L6.26193932,17.6476484 Z"
                                fill="#000000"
                                fill-rule="nonzero"
                                transform="translate(11.999995, 12.000002) rotate(-180.000000) translate(-11.999995, -12.000002)"
                              />
                            </g>
                          </svg>
                        </span>
                      </span>
                    </div>
                    <div class="wizard-title">
                      Validation par <br />Doyen du College
                    </div>
                  </div>
                  <!--end::Wizard Step 5 Nav-->
                </div>
              </div>
              <!--end: Wizard Nav-->
              <!--begin: Wizard Body-->
            </div>
            <!--end: Wizard-->
            <form action="#" method="POST">
              <div
                class="d-flex justify-content-around etat-validation-dates pt-4"
              >
                <div class="validation-debut-vacation">
                  <label class="d-block">Début des vacations:</label>
                  <div class="d-flex">
                    <span class="svg-icon svg-icon-2x mr-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        width="24px"
                        height="24px"
                        viewBox="0 0 24 24"
                        version="1.1"
                      >
                        <g
                          stroke="none"
                          stroke-width="1"
                          fill="none"
                          fill-rule="evenodd"
                        >
                          <rect x="0" y="0" width="24" height="24" />
                          <rect
                            fill="#000000"
                            x="2"
                            y="5"
                            width="19"
                            height="4"
                            rx="1"
                          />
                          <rect
                            fill="#000000"
                            opacity="0.3"
                            x="2"
                            y="11"
                            width="19"
                            height="10"
                            rx="1"
                          />
                        </g>
                      </svg>
                    </span>
                    <datepicker
                      v-model="acte_engagement.date_debut_vacation"
                      name="date_debut_vacation"
                      format="yyyy-MM-dd"
                      bootstrapStyling
                    ></datepicker>
                  </div>
                </div>
                <div class="validation-fin-vacation">
                  <label class="d-block">Fin des vacations:</label>
                  <div class="d-flex">
                    <span class="svg-icon svg-icon-2x mr-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        width="24px"
                        height="24px"
                        viewBox="0 0 24 24"
                        version="1.1"
                      >
                        <g
                          stroke="none"
                          stroke-width="1"
                          fill="none"
                          fill-rule="evenodd"
                        >
                          <rect x="0" y="0" width="24" height="24" />
                          <rect
                            fill="#000000"
                            x="2"
                            y="5"
                            width="19"
                            height="4"
                            rx="1"
                          />
                          <rect
                            fill="#000000"
                            opacity="0.3"
                            x="2"
                            y="11"
                            width="19"
                            height="10"
                            rx="1"
                          />
                        </g>
                      </svg>
                    </span>
                    <datepicker
                      v-model="acte_engagement.date_fin_vacation"
                      name="date_fin_vacation"
                      format="yyyy-MM-dd"
                      bootstrapStyling
                    ></datepicker>
                  </div>
                </div>

                <div
                  v-if="acte_engagement.vacataire.type == 'Mensualisé'"
                  class="validation-mode-paiment"
                >
                  <div
                    v-if="acte_engagement.etape == 'Initialiser'"
                    class="form-group"
                  >
                    <label class="d-block">Mensualité (DH):</label>
                    <input
                      name="mensualite"
                      type="number"
                      class="form-control"
                      v-model="acte_engagement.mensualite"
                    />
                    <span class="bmd-help">Mensualité par mois</span>
                  </div>

                  <span v-else>
                    <label class="d-block">Mode de paiement:</label>
                    <i class="flaticon2-right-arrow mr-2"></i>
                    <span
                      v-if="
                        acte_engagement.mode_paiement == 'A la fin du semestre'
                      "
                    >
                      A la fin du semestre
                    </span>
                    <span
                      v-else-if="
                        acte_engagement.mode_paiement == 'Mensuellement'
                      "
                    >
                      Mensuellement
                    </span>
                  </span>
                </div>
              </div>

              <div
                v-if="
                  acte_engagement.etape == 'Initialiser' &&
                  (user.role.nom == 'DE' || user.role.nom == 'ASST')
                "
                style="text-align: center"
                class="mt-2 mb-2"
              >
                <button
                  @click.prevent="updateDateVacation()"
                  class="font-size-16 btn bg-4979E8 color-FFFFFF pl-10 pr-14 py-3"
                >
                  <span
                    class="svg-icon svg-icon-white svg-icon-primary svg-icon-2x"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      width="24px"
                      height="24px"
                      viewBox="0 0 24 24"
                      version="1.1"
                    >
                      <g
                        stroke="none"
                        stroke-width="1"
                        fill="none"
                        fill-rule="evenodd"
                      >
                        <polygon points="0 0 24 0 24 24 0 24" />
                        <path
                          d="M9.26193932,16.6476484 C8.90425297,17.0684559 8.27315905,17.1196257 7.85235158,16.7619393 C7.43154411,16.404253 7.38037434,15.773159 7.73806068,15.3523516 L16.2380607,5.35235158 C16.6013618,4.92493855 17.2451015,4.87991302 17.6643638,5.25259068 L22.1643638,9.25259068 C22.5771466,9.6195087 22.6143273,10.2515811 22.2474093,10.6643638 C21.8804913,11.0771466 21.2484189,11.1143273 20.8356362,10.7474093 L17.0997854,7.42665306 L9.26193932,16.6476484 Z"
                          fill="#000000"
                          fill-rule="nonzero"
                          opacity="0.3"
                          transform="translate(14.999995, 11.000002) rotate(-180.000000) translate(-14.999995, -11.000002) "
                        />
                        <path
                          d="M4.26193932,17.6476484 C3.90425297,18.0684559 3.27315905,18.1196257 2.85235158,17.7619393 C2.43154411,17.404253 2.38037434,16.773159 2.73806068,16.3523516 L11.2380607,6.35235158 C11.6013618,5.92493855 12.2451015,5.87991302 12.6643638,6.25259068 L17.1643638,10.2525907 C17.5771466,10.6195087 17.6143273,11.2515811 17.2474093,11.6643638 C16.8804913,12.0771466 16.2484189,12.1143273 15.8356362,11.7474093 L12.0997854,8.42665306 L4.26193932,17.6476484 Z"
                          fill="#000000"
                          fill-rule="nonzero"
                          transform="translate(9.999995, 12.000002) rotate(-180.000000) translate(-9.999995, -12.000002) "
                        />
                      </g>
                    </svg>
                  </span>
                  Modifier
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!--end::Steper-->

    <!--begin:Activities-->
    <div class="pt-8 d-flex">
      <!--begin::Container-->
      <div class="container">
        <div class="row">
          <div class="col-xl-12">
            <div class="d-flex align-items-end justify-content-between">
              <h5 class="card-title">ACTIVITÉ(S)</h5>
              <div
                class="mr-2"
                v-if="
                  acte_engagement.etape == 'Initialiser' &&
                  acte_engagement.vacataire.valider &&
                  (user.role.nom == 'DE' || user.role.nom == 'ASST')
                "
              >
                <button
                  type="button"
                  data-toggle="modal"
                  data-target="#AddActivity"
                  class="mb-3 btn btn-sm bg-green text-color-green py-4 pl-6 pr-10"
                >
                  <span
                    class="svg-size-20 svg-icon svg-icon-green svg-icon-2x mr-5"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      width="24px"
                      height="24px"
                      viewBox="0 0 24 24"
                      version="1.1"
                    >
                      <g
                        stroke="none"
                        stroke-width="1"
                        fill="none"
                        fill-rule="evenodd"
                      >
                        <rect x="0" y="0" width="24" height="24"></rect>
                        <circle
                          fill="#000000"
                          opacity="0.3"
                          cx="12"
                          cy="12"
                          r="10"
                        ></circle>
                        <path
                          d="M11,11 L11,7 C11,6.44771525 11.4477153,6 12,6 C12.5522847,6 13,6.44771525 13,7 L13,11 L17,11 C17.5522847,11 18,11.4477153 18,12 C18,12.5522847 17.5522847,13 17,13 L13,13 L13,17 C13,17.5522847 12.5522847,18 12,18 C11.4477153,18 11,17.5522847 11,17 L11,13 L7,13 C6.44771525,13 6,12.5522847 6,12 C6,11.4477153 6.44771525,11 7,11 L11,11 Z"
                          fill="#000000"
                        ></path>
                      </g>
                    </svg>
                  </span>
                  <span class="font-size-14 vertical-align-middle">
                    Ajouter une activité
                  </span>
                </button>
              </div>
            </div>
            <div class="bg-white-raduis py-7 px-5">
              <div
                v-if="activities.length == 0"
                class="empty-datas py-5"
              >
                <div class="d-flex justify-content-center">
                  <span class="svg-icon fill- svg-icon-5x">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      width="24px"
                      height="24px"
                      viewBox="0 0 24 24"
                      version="1.1"
                    >
                      <g
                        stroke="none"
                        stroke-width="1"
                        fill="none"
                        fill-rule="evenodd"
                      >
                        <rect x="0" y="0" width="24" height="24" />
                        <path
                          d="M4,4 L11.6314229,2.5691082 C11.8750185,2.52343403 12.1249815,2.52343403 12.3685771,2.5691082 L20,4 L20,13.2830094 C20,16.2173861 18.4883464,18.9447835 16,20.5 L12.5299989,22.6687507 C12.2057287,22.8714196 11.7942713,22.8714196 11.4700011,22.6687507 L8,20.5 C5.51165358,18.9447835 4,16.2173861 4,13.2830094 L4,4 Z"
                          fill="#000000"
                          opacity="0.3"
                        />
                        <path
                          d="M10.5857864,12 L9.17157288,10.5857864 C8.78104858,10.1952621 8.78104858,9.56209717 9.17157288,9.17157288 C9.56209717,8.78104858 10.1952621,8.78104858 10.5857864,9.17157288 L12,10.5857864 L13.4142136,9.17157288 C13.8047379,8.78104858 14.4379028,8.78104858 14.8284271,9.17157288 C15.2189514,9.56209717 15.2189514,10.1952621 14.8284271,10.5857864 L13.4142136,12 L14.8284271,13.4142136 C15.2189514,13.8047379 15.2189514,14.4379028 14.8284271,14.8284271 C14.4379028,15.2189514 13.8047379,15.2189514 13.4142136,14.8284271 L12,13.4142136 L10.5857864,14.8284271 C10.1952621,15.2189514 9.56209717,15.2189514 9.17157288,14.8284271 C8.78104858,14.4379028 8.78104858,13.8047379 9.17157288,13.4142136 L10.5857864,12 Z"
                          fill="#000000"
                        />
                      </g>
                    </svg>
                  </span>
                </div>
                <div class="d-flex justify-content-center">
                  <span class="color-A7AED3 font-size-16">
                    Aucune activité d'enseignement n'est saisie et enregistré…
                  </span>
                </div>
              </div>

              <table v-else class="table table-borderless mb-0 table-v1">
                <thead>
                  <tr>
                    <th scope="col">Matière/Activité</th>
                    <th scope="col">Filière/Promotion</th>
                    <th scope="col">Type-VH-Taux</th>
                    <th scope="col">Autres</th>

                    <th
                      v-if="
                        acte_engagement.etape == 'Initialiser' &&
                        (user.role.nom == 'DE' || user.role.nom == 'ASST')
                      "
                      data-sortable="false"
                    >
                      action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="activity in activities" :key="activity.id">
                    <td style="width: 25%">
                      {{ activity.matiere.nom }}
                    </td>
                    <td style="width: 25%">
                      <ul
                        v-for="filiere in activity.filieres"
                        :key="filiere.id"
                      >
                        <li>{{ filiere.code }} - {{ filiere.promotion }}</li>
                      </ul>
                    </td>
                    <td style="width: 25%">
                      <div
                        v-for="detail in activity.activity_details"
                        :key="detail.id"
                        class="d-flex justify-content-between align-content-center"
                      >
                        <div>
                          <ul>
                            <li>
                              {{ detail.type }} - {{ detail.volume_horaire }} H
                              - {{ detail.taux }} DH
                            </li>
                          </ul>
                        </div>

                        <div
                          v-if="
                            acte_engagement.etape == 'Initialiser' &&
                            (user.role.nom == 'DE' || user.role.nom == 'ASST')
                          "
                          class="dropdown dropdown-inline float-right"
                        >
                          <button
                            type="button"
                            class="btn btn-hover-light-primary btn-icon btn-sm"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            <i class="ki ki-more-ver"></i>
                          </button>
                          <div
                            class="dropdown-menu dropdown-menu-sm dropdown-menu-right px-2"
                          >
                            <button
                              class="dropdown-item editDetail drpdown"
                              data-toggle="modal"
                              data-target="#EditDetails"
                            >
                              Modifier
                            </button>

                            <button
                              class="dropdown-item deleteDetail"
                              data-toggle="modal"
                              data-target="#deleteDetails"
                            >
                              Supprimer
                            </button>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td style="width: 25%">
                      {{ activity.autre }}
                    </td>
                    <td
                      v-if="
                        acte_engagement.etape == 'Initialiser' &&
                        (user.role.nom == 'DE' || user.role.nom == 'ASST')
                      "
                    >
                      <button
                        type="button"
                        class="btn btn-hover-light-primary btn-icon btn-sm"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <i class="ki ki-more-ver"></i>
                      </button>
                      <div class="dropdown-menu">
                        <button
                          class="dropdown-item addDetail"
                          data-toggle="modal"
                          data-target="#AddDetails"
                        >
                          Ajoute Details
                        </button>
                        <button
                          class="dropdown-item editActivity"
                          data-toggle="modal"
                          data-target="#EditActivity"
                        >
                          Modifier Activity
                        </button>
                        <button
                          class="dropdown-item deleteActivity"
                          @click="delete_activity_modal(activity.id)"
                        >
                          Supprimer Activité
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end:Activities-->

    <div
      class="modal fade"
      id="new_avenant_modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="#modal_ajout_activite_header"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content p-5">
          <div class="modal-header pb-3">
            <h5 class="modal-title" id="modal_ajout_activite_header">
              AJOUTER UN AVENANT
            </h5>
            <button
              type="button"
              class="btn btn-sm btn-icon btn-secondary btn-circle close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <i aria-hidden="true" class="fas fa-times"></i>
            </button>
          </div>
          <form action="#">
            <div class="modal-body px-0 py-4 d-flex justify-content-around">
              <div>
                <select
                  name="type"
                  style="width: 250px"
                  class="selectpicker type_avenant"
                  data-size="7"
                  title="Select type d'avenant"
                  v-model="new_avenant_type"
                >
                  <option value="Ajouter activitie">
                    Ajouter une activité
                  </option>
                  <option value="Ajouter volume horaire a une activitie">
                    Ajouter un VH d'une activité
                  </option>
                  <option value="Annuler acte d'engagement">
                    Annuler Acte d'engagement
                  </option>
                </select>
              </div>
            </div>
            <div class="modal-footer">
              <button
                @click="save_avenant()"
                type="button"
                class="btn btn-primary pl-10 pr-14 py-3"
              >
                <span
                  class="svg-icon svg-icon-white svg-icon-primary svg-icon-2x"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    version="1.1"
                  >
                    <g
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <polygon points="0 0 24 0 24 24 0 24" />
                      <path
                        d="M9.26193932,16.6476484 C8.90425297,17.0684559 8.27315905,17.1196257 7.85235158,16.7619393 C7.43154411,16.404253 7.38037434,15.773159 7.73806068,15.3523516 L16.2380607,5.35235158 C16.6013618,4.92493855 17.2451015,4.87991302 17.6643638,5.25259068 L22.1643638,9.25259068 C22.5771466,9.6195087 22.6143273,10.2515811 22.2474093,10.6643638 C21.8804913,11.0771466 21.2484189,11.1143273 20.8356362,10.7474093 L17.0997854,7.42665306 L9.26193932,16.6476484 Z"
                        fill="#000000"
                        fill-rule="nonzero"
                        opacity="0.3"
                        transform="translate(14.999995, 11.000002) rotate(-180.000000) translate(-14.999995, -11.000002) "
                      />
                      <path
                        d="M4.26193932,17.6476484 C3.90425297,18.0684559 3.27315905,18.1196257 2.85235158,17.7619393 C2.43154411,17.404253 2.38037434,16.773159 2.73806068,16.3523516 L11.2380607,6.35235158 C11.6013618,5.92493855 12.2451015,5.87991302 12.6643638,6.25259068 L17.1643638,10.2525907 C17.5771466,10.6195087 17.6143273,11.2515811 17.2474093,11.6643638 C16.8804913,12.0771466 16.2484189,12.1143273 15.8356362,11.7474093 L12.0997854,8.42665306 L4.26193932,17.6476484 Z"
                        fill="#000000"
                        fill-rule="nonzero"
                        transform="translate(9.999995, 12.000002) rotate(-180.000000) translate(-9.999995, -12.000002) "
                      />
                    </g>
                  </svg>
                </span>
                Enregistrer
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="delete_avenant_modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="#delete_avenant_modal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content p-5">
          <form action="" method="post">
            <div class="modal-header pb-3">
              <h5 class="modal-title" id="modal_enregistrer_header">
                Supprimer Avenant
              </h5>
              <button
                type="button"
                class="btn btn-sm btn-icon btn-secondary btn-circle close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <i aria-hidden="true" class="fas fa-times"></i>
              </button>
            </div>
            <div class="modal-body px-0 py-4 pb-8">
              <div class="d-flex justify-content-center">
                <span class="svg-icon svg-icon-danger svg-icon-10x">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    version="1.1"
                  >
                    <g
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <rect x="0" y="0" width="24" height="24" />
                      <circle
                        fill="#000000"
                        opacity="0.3"
                        cx="12"
                        cy="12"
                        r="10"
                      />
                      <rect
                        fill="#000000"
                        x="11"
                        y="7"
                        width="2"
                        height="8"
                        rx="1"
                      />
                      <rect
                        fill="#000000"
                        x="11"
                        y="16"
                        width="2"
                        height="2"
                        rx="1"
                      />
                    </g>
                  </svg>
                </span>
              </div>
              <div class="">
                <p class="ff-helvetica fs-21 color-707070">
                  Vous êtes sûr de supprimer cet avenant ?
                </p>
              </div>
            </div>
            <div class="d-flex justify-content-between modal-footer">
              <button
                type="button"
                class="btn bg-D38686 color-FFFFFF px-16 py-3"
                data-dismiss="modal"
                aria-label="Close"
              >
                ANNULER
              </button>
              <button
                @click="delete_avenant()"
                type="button"
                class="btn btn-primary pl-10 pr-14 py-3"
              >
                <span
                  class="svg-icon svg-icon-white svg-icon-primary svg-icon-2x"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    version="1.1"
                  >
                    <g
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <polygon points="0 0 24 0 24 24 0 24" />
                      <path
                        d="M9.26193932,16.6476484 C8.90425297,17.0684559 8.27315905,17.1196257 7.85235158,16.7619393 C7.43154411,16.404253 7.38037434,15.773159 7.73806068,15.3523516 L16.2380607,5.35235158 C16.6013618,4.92493855 17.2451015,4.87991302 17.6643638,5.25259068 L22.1643638,9.25259068 C22.5771466,9.6195087 22.6143273,10.2515811 22.2474093,10.6643638 C21.8804913,11.0771466 21.2484189,11.1143273 20.8356362,10.7474093 L17.0997854,7.42665306 L9.26193932,16.6476484 Z"
                        fill="#000000"
                        fill-rule="nonzero"
                        opacity="0.3"
                        transform="translate(14.999995, 11.000002) rotate(-180.000000) translate(-14.999995, -11.000002) "
                      />
                      <path
                        d="M4.26193932,17.6476484 C3.90425297,18.0684559 3.27315905,18.1196257 2.85235158,17.7619393 C2.43154411,17.404253 2.38037434,16.773159 2.73806068,16.3523516 L11.2380607,6.35235158 C11.6013618,5.92493855 12.2451015,5.87991302 12.6643638,6.25259068 L17.1643638,10.2525907 C17.5771466,10.6195087 17.6143273,11.2515811 17.2474093,11.6643638 C16.8804913,12.0771466 16.2484189,12.1143273 15.8356362,11.7474093 L12.0997854,8.42665306 L4.26193932,17.6476484 Z"
                        fill="#000000"
                        fill-rule="nonzero"
                        transform="translate(9.999995, 12.000002) rotate(-180.000000) translate(-9.999995, -12.000002) "
                      />
                    </g>
                  </svg>
                </span>
                Supprimer
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="delete_activity_modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="#delete_activity_modal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content p-5">
          <form action="" method="post">
            <div class="modal-header pb-3">
              <h5 class="modal-title" id="modal_enregistrer_header">
                Supprimer activité
              </h5>
              <button
                type="button"
                class="btn btn-sm btn-icon btn-secondary btn-circle close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <i aria-hidden="true" class="fas fa-times"></i>
              </button>
            </div>
            <div class="modal-body px-0 py-4 pb-8">
              <div class="d-flex justify-content-center">
                <span class="svg-icon svg-icon-danger svg-icon-10x">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    version="1.1"
                  >
                    <g
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <rect x="0" y="0" width="24" height="24" />
                      <circle
                        fill="#000000"
                        opacity="0.3"
                        cx="12"
                        cy="12"
                        r="10"
                      />
                      <rect
                        fill="#000000"
                        x="11"
                        y="7"
                        width="2"
                        height="8"
                        rx="1"
                      />
                      <rect
                        fill="#000000"
                        x="11"
                        y="16"
                        width="2"
                        height="2"
                        rx="1"
                      />
                    </g>
                  </svg>
                </span>
              </div>
              <div class="">
                <p class="ff-helvetica fs-21 color-707070">
                  Vous êtes sûr de supprimer cet activité ?
                </p>
              </div>
            </div>
            <div class="d-flex justify-content-between modal-footer">
              <button
                type="button"
                class="btn bg-D38686 color-FFFFFF px-16 py-3"
                data-dismiss="modal"
                aria-label="Close"
              >
                ANNULER
              </button>
              <button
                @click="delete_activity()"
                type="button"
                class="btn btn-primary pl-10 pr-14 py-3"
              >
                <span
                  class="svg-icon svg-icon-white svg-icon-primary svg-icon-2x"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    version="1.1"
                  >
                    <g
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <polygon points="0 0 24 0 24 24 0 24" />
                      <path
                        d="M9.26193932,16.6476484 C8.90425297,17.0684559 8.27315905,17.1196257 7.85235158,16.7619393 C7.43154411,16.404253 7.38037434,15.773159 7.73806068,15.3523516 L16.2380607,5.35235158 C16.6013618,4.92493855 17.2451015,4.87991302 17.6643638,5.25259068 L22.1643638,9.25259068 C22.5771466,9.6195087 22.6143273,10.2515811 22.2474093,10.6643638 C21.8804913,11.0771466 21.2484189,11.1143273 20.8356362,10.7474093 L17.0997854,7.42665306 L9.26193932,16.6476484 Z"
                        fill="#000000"
                        fill-rule="nonzero"
                        opacity="0.3"
                        transform="translate(14.999995, 11.000002) rotate(-180.000000) translate(-14.999995, -11.000002) "
                      />
                      <path
                        d="M4.26193932,17.6476484 C3.90425297,18.0684559 3.27315905,18.1196257 2.85235158,17.7619393 C2.43154411,17.404253 2.38037434,16.773159 2.73806068,16.3523516 L11.2380607,6.35235158 C11.6013618,5.92493855 12.2451015,5.87991302 12.6643638,6.25259068 L17.1643638,10.2525907 C17.5771466,10.6195087 17.6143273,11.2515811 17.2474093,11.6643638 C16.8804913,12.0771466 16.2484189,12.1143273 15.8356362,11.7474093 L12.0997854,8.42665306 L4.26193932,17.6476484 Z"
                        fill="#000000"
                        fill-rule="nonzero"
                        transform="translate(9.999995, 12.000002) rotate(-180.000000) translate(-9.999995, -12.000002) "
                      />
                    </g>
                  </svg>
                </span>
                Supprimer
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="AddActivity"
      tabindex="-1"
      role="dialog"
      aria-labelledby="#modal_ajout_activite_header"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content p-5">
          <div class="modal-header pb-3">
            <h5 class="modal-title" id="modal_ajout_activite_header">
              AJOUTER UNE ACTIVITÉ
            </h5>
            <button
              type="button"
              class="btn btn-sm btn-icon btn-secondary btn-circle close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <i aria-hidden="true" class="fas fa-times"></i>
            </button>
          </div>
          <form action="#" method="post" enctype="multipart/form-data">
            <div class="modal-body px-0 py-4">
              <div>
                <div class="row">
                  <div class="col-md-6 form-group">
                    <label for="matiere_id" class="ml-3"
                      >Choisir une matière</label
                    >
                    <select
                      name="matiere_id"
                      v-model="matiere"
                      class="form-control selectpicker"
                      data-live-search="true"
                      data-size="7"
                      data-style="select-with-transition"
                      title="Select Matière"
                    >
                      <option
                        style="width: 97%"
                        v-for="matiere in matieres"
                        :key="`matiere_${matiere.id}`"
                        :value="matiere.id"
                      >
                        {{
                          matiere.service_id +
                          "/" +
                          matiere.serviceoff_id +
                          " : " +
                          matiere.nom
                        }}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-6 form-group">
                    <label>Choisir les filières</label>
                    <select
                      name="filieres[]"
                      v-model="selected_filieres"
                      class="form-control selectpicker"
                      data-live-search="true"
                      multiple
                    >
                      <option
                        v-for="filiere in filieres"
                        :key="`filiere_${filiere.id}`"
                        :value="filiere.id"
                      >
                        {{ filiere.code + "-" + filiere.promotion }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="modal-table mb-4">
                  <table class="table">
                    <thead>
                      <tr>
                        <th scope="col">TYPE</th>
                        <th scope="col">VOLUME</th>
                        <th scope="col">TAUX</th>
                        <th v-if="engager == 1" scope="col" class="text-right">
                          <span
                            class="prix-max btn btn-dark font-weight-bold btn-pill"
                            >{{ heurs_rest }}H MAX</span
                          >
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr class="bg-grey">
                        <td>
                          <select
                            v-model="type"
                            name="type"
                            style="margin-top: 0px"
                            class="form-control"
                          >
                            <option
                              v-for="(type, index) in types"
                              :key="`type_${index}`"
                              style="width: 95%"
                              :value="type.titre"
                            >
                              {{ type.titre }}
                            </option>
                          </select>
                        </td>
                        <td>
                          <div class="input-group">
                            <input
                              type="text"
                              v-model="volume_horaire"
                              class="form-control"
                              placeholder="Volume Horaire"
                            />
                            <div class="input-group-append">
                              <span class="input-group-text">H</span>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="input-group">
                            <input
                              v-model="taux"
                              type="text"
                              class="form-control"
                              placeholder="Taux"
                            />
                            <div class="input-group-append">
                              <span class="input-group-text">DH</span>
                            </div>
                          </div>
                        </td>
                        <td>
                          <button
                            type="button"
                            v-if="
                              type != null &&
                              volume_horaire != null &&
                              taux != null
                            "
                            class="btn-plus btn btn-sm btn-icon btn-secondary btn-circle"
                          >
                            <i
                              aria-hidden="true"
                              @click="ajouter_detail"
                              class="fas fa-plus"
                            ></i>
                          </button>
                        </td>
                      </tr>
                      <input type="hidden" name="details" v-model="data" />
                      <tr
                        v-for="(detail, index) in details"
                        :key="`detail_${index}`"
                      >
                        <td>{{ detail.type }}</td>
                        <td>{{ detail.volume_horaire }}</td>
                        <td>{{ detail.taux }}</td>
                        <td>
                          <a
                            class="btn-minus btn btn-sm btn-icon btn-secondary btn-circle"
                            @click.prevent="supprimer_detail(index)"
                            href="#"
                          >
                            <i class="fas fa-minus"></i>
                          </a>
                        </td>
                      </tr>
                      <tr style="text-align: center" v-if="!details.length">
                        <td colspan="4">Aucun détail trouvé…</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="form-group">
                  <label>Autre</label>
                  <textarea
                    v-model="autre"
                    class="form-control"
                    name="autre"
                    rows="3"
                  ></textarea>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                @click="save_activity"
                class="btn btn-primary pl-10 pr-14 py-3"
              >
                <span
                  class="svg-icon svg-icon-white svg-icon-primary svg-icon-2x"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    version="1.1"
                  >
                    <g
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <polygon points="0 0 24 0 24 24 0 24" />
                      <path
                        d="M9.26193932,16.6476484 C8.90425297,17.0684559 8.27315905,17.1196257 7.85235158,16.7619393 C7.43154411,16.404253 7.38037434,15.773159 7.73806068,15.3523516 L16.2380607,5.35235158 C16.6013618,4.92493855 17.2451015,4.87991302 17.6643638,5.25259068 L22.1643638,9.25259068 C22.5771466,9.6195087 22.6143273,10.2515811 22.2474093,10.6643638 C21.8804913,11.0771466 21.2484189,11.1143273 20.8356362,10.7474093 L17.0997854,7.42665306 L9.26193932,16.6476484 Z"
                        fill="#000000"
                        fill-rule="nonzero"
                        opacity="0.3"
                        transform="translate(14.999995, 11.000002) rotate(-180.000000) translate(-14.999995, -11.000002) "
                      />
                      <path
                        d="M4.26193932,17.6476484 C3.90425297,18.0684559 3.27315905,18.1196257 2.85235158,17.7619393 C2.43154411,17.404253 2.38037434,16.773159 2.73806068,16.3523516 L11.2380607,6.35235158 C11.6013618,5.92493855 12.2451015,5.87991302 12.6643638,6.25259068 L17.1643638,10.2525907 C17.5771466,10.6195087 17.6143273,11.2515811 17.2474093,11.6643638 C16.8804913,12.0771466 16.2484189,12.1143273 15.8356362,11.7474093 L12.0997854,8.42665306 L4.26193932,17.6476484 Z"
                        fill="#000000"
                        fill-rule="nonzero"
                        transform="translate(9.999995, 12.000002) rotate(-180.000000) translate(-9.999995, -12.000002) "
                      />
                    </g>
                  </svg>
                </span>
                Enregistrer
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
export default {
  components: {
    Datepicker,
  },
  props: {
    user: {},
    matieres: Array,
    filieres: Array,
    acte_engagement: {},
    heurs_rest: Number,
    types: Array,
    acte_non_legalise: {},
    acte_legalise: {},
  },
  data() {
    return {
      new_avenant_type: "Ajouter activitie",
      avenants: [],
      avenant: {},
      matiere: null,
      selected_filieres: [],
      volume_horaire: null,
      taux: null,
      type: null,
      details: [],
      data: [],
      autre: null,
      engager: null,
      activity_id: null,
      activities: [],
    };
  },
  methods: {
    ajouter_detail() {
      this.details.push({
        volume_horaire: this.volume_horaire,
        taux: this.taux,
        type: this.type,
      });
      this.volume_horaire = this.taux = this.type = null;
      setTimeout(function () {
        $("#type").selectpicker("refresh");
      }, 200);
    },
    supprimer_detail(index) {
      this.details.pop(index);
    },
    new_avenant_modal() {
      $("#new_avenant_modal").modal("show");
    },
    save_avenant() {
      let config = {
        headers: {
          Authorization: "Bearer " + this.user.api_token,
        },
      };
      axios
        .post(
          "/api/avenant/save",
          {
            type: this.new_avenant_type,
            acte_engagement_id: this.acte_engagement.id,
          },
          config
        )
        .then((response) => {
          this.reload_avenants();
          $("#new_avenant_modal").modal("hide");
          //redirect to avenant after saving
          if (response.data.type == "Ajouter activitie") {
            window.location.href =
              "/administration/avenant/new-activitie/" +
              response.data.acte_engagement_id +
              "/" +
              response.data.id;
          }
          if (response.data.type == "Ajouter volume horaire a une activitie") {
            window.location.href =
              "/administration/avenant/add-vh-activitie/" +
              response.data.acte_engagement_id +
              "/" +
              response.data.id;
          }
          if (response.data.type == "Annuler acte d'engagement") {
            window.location.href =
              "/administration/avenant/annulation-AE/" +
              response.data.acte_engagement_id +
              "/" +
              response.data.id;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    show_avenant(avenant) {
      if (avenant.type == "Ajouter activitie") {
        window.location.href =
          "/administration/avenant/new-activitie/" +
          avenant.acte_engagement_id +
          "/" +
          avenant.id;
      }
      if (avenant.type == "Ajouter volume horaire a une activitie") {
        window.location.href =
          "/administration/avenant/add-vh-activitie/" +
          avenant.acte_engagement_id +
          "/" +
          avenant.id;
      }
      if (avenant.type == "Annuler acte d'engagement") {
        window.location.href =
          "/administration/avenant/annulation-AE/" +
          avenant.acte_engagement_id +
          "/" +
          avenant.id;
      }
    },
    delete_avenant_modal(avenant) {
      this.avenant = avenant;
      $("#delete_avenant_modal").modal("show");
    },
    delete_activity_modal(activity_id) {
      this.activity_id = activity_id;
      $("#delete_activity_modal").modal("show");
    },
    delete_avenant() {
      let config = {
        headers: {
          Authorization: "Bearer " + this.user.api_token,
        },
      };
      axios
        .delete("/api/avenant/delete/" + this.avenant.id, config)
        .then((response) => {
          this.avenant = {};
          this.reload_avenants();
          $("#delete_avenant_modal").modal("hide");
          Vue.swal.fire({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            title: "Avenant Supprimé!",
            icon: "success",
            confirmButtonText: "Cool",
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    reload_avenants() {
      let config = {
        headers: {
          Authorization: "Bearer " + this.user.api_token,
        },
      };
      axios
        .get("/api/avenants/" + this.acte_engagement.id, config)
        .then((response) => {
          this.avenants = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    updateDateVacation() {
      let config = {
        headers: {
          Authorization: "Bearer " + this.user.api_token,
        },
      };
      axios
        .post(
          "/api/acte/update_date",
          {
            acte_engagement_id: this.acte_engagement.id,
            date_debut_vacation: moment(
              this.acte_engagement.date_debut_vacation
            ).format("yyyy-MM-DD"),
            date_fin_vacation: moment(
              this.acte_engagement.date_fin_vacation
            ).format("yyyy-MM-DD"),
          },
          config
        )
        .then((response) => {
          Vue.swal.fire({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            title: "Date vacation modifié!",
            icon: "success",
            confirmButtonText: "Cool",
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    save_activity() {
      let config = {
        headers: {
          Authorization: "Bearer " + this.user.api_token,
        },
      };
      axios
        .post(
          "/api/acte/save/activite",
          {
            acte_engagement_id: this.acte_engagement.id,
            details: this.details,
            filieres: this.selected_filieres,
            autre: this.autre,
            matiere_id: this.matiere,
          },
          config
        )
        .then((response) => {
          $("#AddActivity").modal("hide");
          this.details = [];
          Vue.swal.fire({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            title: "Activité ajoutée!",
            icon: "success",
            confirmButtonText: "Cool",
          });
          this.reload_avtivities();
        })
        .catch((error) => {
          console.log(error);
        });
    },

    delete_activity() {
      let config = {
        headers: {
          Authorization: "Bearer " + this.user.api_token,
        },
      };
      axios
        .delete("/api/acte/delete/activite/" + this.activity_id, config)
        .then((response) => {
          this.reload_avtivities();
          $("#delete_activity_modal").modal("hide");
          this.activity_id = null;
          Vue.swal.fire({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            title: "Activité supprimée !",
            icon: "success",
            confirmButtonText: "Cool",
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    reload_avtivities() {
      let config = {
        headers: {
          Authorization: "Bearer " + this.user.api_token,
        },
      };
      axios
        .get("/api/activities/" + this.acte_engagement.id, config)
        .then((response) => {
          this.activities = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  mounted() {
    //activities
    this.activities = this.acte_engagement.activities;

    //check if vacataire valide his profil
    if (this.acte_engagement.vacataire.engager == 1) {
      this.engager = 1;
    } else {
      this.engager = 0;
    }

    //avenants
    this.avenants = this.acte_engagement.avenants;

    // steper conditions
    if (
      this.acte_engagement.etape == "Initialiser" ||
      this.acte_engagement.etape == "Distrubition des activités terminé" ||
      this.acte_engagement.etape == "Valider par Vacataire" ||
      this.acte_engagement.etape == "Valider par DE" ||
      this.acte_engagement.etape == "Valider par DOYEN"
    ) {
      var Inititialisation = document.getElementById("Inititialisation");
      Inititialisation.setAttribute("data-wizard-state", "done");
    }

    if (
      this.acte_engagement.etape == "Distrubition des activités terminé" ||
      this.acte_engagement.etape == "Valider par Vacataire" ||
      this.acte_engagement.etape == "Valider par DE" ||
      this.acte_engagement.etape == "Valider par DOYEN"
    ) {
      var Distribution_des_activite = document.getElementById(
        "Distribution_des_activite"
      );
      Distribution_des_activite.setAttribute("data-wizard-state", "done");
    }

    if (
      this.acte_engagement.etape == "Valider par Vacataire" ||
      this.acte_engagement.etape == "Valider par DE" ||
      this.acte_engagement.etape == "Valider par DOYEN"
    ) {
      var validation_vacataire = document.getElementById(
        "validation_vacataire"
      );
      validation_vacataire.setAttribute("data-wizard-state", "done");
    }

    if (
      this.acte_engagement.etape == "Valider par DE" ||
      this.acte_engagement.etape == "Valider par DOYEN"
    ) {
      var validation_DE = document.getElementById("validation_DE");
      validation_DE.setAttribute("data-wizard-state", "done");
    }

    if (this.acte_engagement.etape == "Valider par DOYEN") {
      var validation_DOYEN = document.getElementById("validation_DOYEN");
      validation_DOYEN.setAttribute("data-wizard-state", "done");
    }
    //end steper conditions
  },
};
</script>
